<template>
  <div class="page-container flex-column">
    <ProjectSearchBar :on-search="onSearch" :on-collapse="onCollapse" class-name="col-0" />
    <div class="mb10 pd-20 col-0">
      <el-button type="primary" size="mini" @click="showCreate"> <i class="el-icon-plus" /> 新建项目 </el-button>
    </div>
    <ProjectTable ref="projectTable" class-name="col-1 scroll projects-projecttable" />
  </div>
</template>

<script>
import ProjectSearchBar from '../components/ProjectSearchBar.vue'
import ProjectTable from '../components/ProjectTable.vue'
// 组件已弃用

export default {
  name: 'Projects',
  components: {
    ProjectSearchBar,
    ProjectTable,
  },
  data() {
    return {}
  },
  methods: {
    onSearch(query) {
      this.$refs.projectTable.setQuery(query)
    },
    showCreate() {
      window.app.root.$refs.addProjectFull.open()
    },
    getProjects() {
      this.$refs.projectTable.getProjects()
    },
    onCollapse() {
      this.$refs.projectTable.initHeight()
    },
  },
}
</script>

<style>
a {
  text-decoration: none;
  cursor: pointer;
}
.flex-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.item-center {
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.item-end {
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}
.col-0 {
  flex: none;
}
.col-1 {
  flex: auto;
}
.col-4 {
  flex: 0 0 33%;
  max-width: 33%;
}
.col-2 {
  flex: 0 0 16%;
  max-width: 16%;
}
.col-6 {
  flex: 0 0 49%;
  max-width: 50%;
}
.mr20 {
  margin-right: 20px;
}
.mr10 {
  margin-right: 10px !important;
}
.ml10 {
  margin-left: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.mr5 {
  margin-right: 5px;
}
.mb5 {
  margin-bottom: 5px;
}
.pd-20 {
  padding: 0 20px;
}
.pd-10 {
  padding: 0 10px;
}
.pd10-y {
  padding: 10px 0;
}
.pd10 {
  padding: 10px !important;
}
.flex-column {
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.flex-column .el-button + .el-button {
  margin-left: 0px;
}
.content-center {
  align-content: center;
}
.scroll {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}
.fullscreen {
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  border-radius: 0 !important;
  max-width: 100vw;
  max-height: 100vh;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  transition: all 0.2s ease-out;
  background: #fff;
}
.page-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 61px 0 0 0;
  max-width: 100vw;
  max-height: 100vh;
  border-radius: 0;
}
.bottom-shadow {
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 0 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.flex-wrap {
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.justify-center {
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.justify-between {
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.justify-around {
  -webkit-justify-content: space-around;
  -ms-flex-pack: justify;
  justify-content: space-around;
}
.right-aside-tab {
  position: relative;
  min-height: 50px;
  max-height: 150px;
  background-color: #fff;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
  border-radius: 4px 0 0 4px;
  padding: 5px 5px 5px 15px;
  cursor: pointer;
  /* 文字垂直 */
  writing-mode: tb-rl;
  -webkit-writing-mode: vertical-rl;
}
.right-aside-tab .el-icon-circle-close-outline {
  display: none;
}
.right-aside-tab:hover .el-icon-circle-close-outline {
  display: inline;
}
/* TODO: start 好像不用了 */
.right-aside-wrapper {
  padding: 60px 0 0 0;
  z-index: 1001;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 0;
  height: 100vh;
  transition: all 0.2s ease-out;
}
.right-aside-wrapper .el-icon-location {
  position: absolute;
  top: 2px;
  left: 2px;
}
.right-aside-wrapper .project {
  color: #fff;
  background: #409eff;
}
.right-aside-wrapper .company {
  color: #fff;
  background: #f56c6c;
}
.right-aside-wrapper .radish {
  color: #fff;
  background: #26a69d;
}
.right-aside-wrapper .radish-right {
  position: relative;
  top: 0;
  border: 0;
  width: 100% !important;
}
.border-shadow {
  border: 1px solid #eaeefb;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.right-aside-content {
  transition: all 0.2s ease-out;
  background: #fff;
  overflow: auto;
  border: 1px solid #eaeefb;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.right-aside-wrapper .right-aside-content .pane-company {
  display: block !important;
  position: relative;
  padding: 0;
}

/* end */
.flex-end {
  justify-content: flex-end;
}
.ft-blue {
  color: #409eff !important;
}
.ft-gray {
  color: #aaa !important;
}
.projects-projecttable {
  padding: 0 40px 0 20px;
}
.full-width {
  width: 100%;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.ft-black {
  color: #000 !important;
}
.bg-gray {
  background-color: #ecebeb !important;
}
.bg-white {
  background-color: #fff !important;
}
.p-relative {
  position: relative;
}
.ft-danger {
  color: #f56c6c !important;
  font-weight: 700;
}
.m-a-10 {
  margin: 10px;
}
.mini_datetime_picker input:hover,
.mini_datetime_picker input:focus {
  padding-left: 30px !important;
}

.tab_item {
  display: inline-block;
  cursor: pointer;
  margin: 0 5px 5px 0;
  padding: 5px 8px;
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
}
.tab_item_default {
  background-color: hsla(220, 4%, 58%, 0.1);
  color: #909399;
}
.tab_item_primary {
  color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}
.tab_item_selected {
  color: #fff;
  background: #409eff;
}
.p_relative {
  position: relative;
}
.block {
  display: block;
  margin: 0;
  padding: 0;
}
.report-template-textarea .el-textarea__inner {
  border: none !important;
  border-bottom: 1px solid #dcdfe6 !important;
  border-radius: 0 !important;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #fafafa;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #9e9e9e;
}
</style>
